import {observer} from 'mobx-react';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {useAccount} from 'wagmi';
import {useBreakpointContext} from '../../../../context-providers/BreakpointProvider';
import {positionsStore} from '../../../../services/position/position.store';
import {getDataGridCommonProps} from '../helpers/data-grid-common-props';

import {getLockHistoryColumns, getLockHistoryColumnsMobile} from '../helpers/columns';
import apiService from "../../../../services/api/api.service";

const PAGE_SIZE = 100;
const emptyStateText = 'No history available';

const LockHistory = observer(() => {

    const { address } = useAccount();
    const { xs } = useBreakpointContext();
    const [historyRecords, setHistoryRecords] = useState<any>([])
    const [paginationEnabled, setPaginationEnabled] = React.useState(positionsStore.openPositionsList.length > PAGE_SIZE);

    useEffect(() => {
        setPaginationEnabled(positionsStore.closedPositions.length > PAGE_SIZE);
    }, [positionsStore.closedPositions.length]);


    useEffect(() => {
        async function fetch() {
            if (address) {
                const history = await apiService.lockingHistoryGet(address);
                setHistoryRecords(history)
            } else {
                positionsStore.resetState()
            }
        }
        fetch()
    }, [address])


    return (
        <div className="LockTabsNavigation__gridWrapper">
            {xs && <DataGrid
                {...getDataGridCommonProps(emptyStateText)}
                rows={historyRecords}
                columns={getLockHistoryColumnsMobile()}
                hideFooter={!paginationEnabled}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: PAGE_SIZE }
                    },
                    sorting: {
                        sortModel: [{ field: 'dateTime', sort: 'desc' }]
                    }
                }}
            />}
            {!xs && <DataGrid
                {...getDataGridCommonProps(emptyStateText)}
                rows={historyRecords}
                columns={getLockHistoryColumns()}
                hideFooter={!paginationEnabled}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: PAGE_SIZE }
                    },
                    sorting: {
                        sortModel: [{ field: 'dateTime', sort: 'desc' }]
                    }
                }}
            />}
        </div>
    );
});

export default LockHistory;
